import { render, staticRenderFns } from "./FizickaOsoba.vue?vue&type=template&id=43f1f46a"
import script from "./FizickaOsoba.vue?vue&type=script&lang=js"
export * from "./FizickaOsoba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports